import { Component, OnInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy, ViewEncapsulation, Input, ElementRef } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, tap } from 'rxjs';

@Component({
  selector: 'waiting-ball-cloak',
  templateUrl: './waiting-ball-cloak.component.html',
  styleUrls: ['./waiting-ball-cloak.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class WaitingBallCloakComponent implements OnInit, OnDestroy {

  @Input() show$: Observable<boolean>;

  @Input() size: number = 24;

  sub: Subscription

  constructor(private wcRef: ElementRef) {  
  }

  ngOnInit() {
  }

  ngAfterViewInit() { 
    if (this.show$ === null) {
      console.error('show$ is null for waiting-ball-cloak');
      return;
    }
    this.sub = 
    this.show$.pipe(tap((val) => {
      if (!val) {
        return;
      }
      //var wc = document.getElementById('waiting-cloak');
      let wc = this.wcRef.nativeElement;
      var dc = wc.parentElement;
      wc.style.width = `calc(${dc.clientWidth}px - ${window.getComputedStyle(dc).paddingLeft} - ${window.getComputedStyle(dc).paddingRight})`;
      wc.style.height = `calc(${dc.clientHeight}px - ${window.getComputedStyle(dc).paddingTop} - ${window.getComputedStyle(dc).paddingBottom})`;
      wc.style.paddingTop = `calc(${dc.clientHeight}px /2 - ${window.getComputedStyle(dc).paddingTop})`
      wc.style.position = 'absolute';
      wc.style.backgroundColor = 'rgba(2, 2, 2, 0.3)';
      wc.style.zIndex = '1000';
      wc.style.display = 'flex';
      wc.style.justifyContent = 'center';
      wc.style.borderRadius = '5px';
    })).subscribe(_ => null);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.sub = null;
  }
}
